import { message, notification } from 'antd'
import { generateMessageError } from 'modules/core/utils'
import i18n from 'i18next'

export const onCreateBudgetType = ({
  form,
  setIsLoading,
  createBudgetType,
  onRefetch,
  onClose,
  sendUserDataToGTM,
}) => {
  form
    .validateFields()
    .then((values) => {
      setIsLoading(true)
      createBudgetType(values)
        .then(() =>
          onRefetch().then(() => {
            message.success(i18n.t('FEEDBACK_CREATE_SUCCESS'), 8)
            onClose()
            sendUserDataToGTM()
          }),
        )
        .catch((error) => {
          notification.error({
            message: i18n.t('FEEDBACK_DEFAULT_ERROR'),
            description: generateMessageError(error, 'FEEDBACK_CREATION_FAIL'),
            duration: 0,
          })
          onClose()
        })
    })
    .catch((e) => {})
}
